import React, { FocusEvent, ChangeEvent } from 'react';
import { Form } from 'react-bootstrap';
import { InputFieldState } from '../types';

/**
 * PhoneNumberFormコンポーネント用のPropsです。
 * @interface PhoneNumberFormProps
 */
interface PhoneNumberFormProps {
  /**
   * 電話番号
   * @type {InputFieldState}
   * @memberof PhoneNumberFormProps
   */
  phoneNumber: InputFieldState;

  /**
   * 電話番号を設定する関数
   * @memberof PhoneNumberFormProps
   */
  onChange: (phoneNumber: InputFieldState) => void;
}

/**
 * 電話番号フォームのコンポーネントです。
 * @param {InputFieldState} props.phoneNumber - 表示する電話番号
 * @param {function} props.onChange - 電話番号が変更されたときに呼ばれるコールバック関数
 * @returns {JSX.Element} - 電話番号フォームのJSX要素
 */
const PhoneNumberForm: React.FC<PhoneNumberFormProps> = ({ phoneNumber, onChange }) => {

  /**
   * フォームからフォーカスが外れたときのイベントハンドラーです。
   * 入力された電話番号を整形し、onChange関数を呼び出します。
   * @param {object} event - フォーカスアウトのイベント
   * @returns {void}
   */
  const handleBlur = (event: FocusEvent<HTMLInputElement>): void => {
    const halfWidthText = event.target.value.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
      return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
    });
    onChange({
      value: halfWidthText,
      errorMessage: ''
    });
  }

  /**
   * フォームの変更イベントハンドラーです。
   * 入力された電話番号をonChange関数を呼び出します。
   * @param {object} event - フォームの変更イベント
   * @returns {void}
   */
  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    onChange({
      value: event.target.value,
      errorMessage: phoneNumber.errorMessage
    });
  }

  return (
    <Form.Group className="mb-2 row">
      <Form.Label className="col-lg-2 col-12 d-flex align-items-center">
        電話番号
        <span className="text-small text-secondary ms-3">※任意</span>
      </Form.Label>
      <div className="col-lg-10 col-12">
        <Form.Control
          type="text"
          value={phoneNumber.value}
          placeholder="電話番号を入力してください。"
          onBlur={handleBlur}
          onChange={handleChange}
          aria-label="電話番号"
          isInvalid={phoneNumber.errorMessage !== ''}
        />
        {phoneNumber.errorMessage !== '' ? <div className="text-end text-danger small">{phoneNumber.errorMessage}</div> : ''}
      </div>
    </Form.Group>
  );
};

export default PhoneNumberForm;